import styled from '@emotion/styled';
import { ClassAttributes, createElement, ReactElement } from 'react';

import { SPACING_UNIT } from '../../constant/spacing';

type Props = ClassAttributes<HTMLElement> & {
  columns: number;
  className?: string;
  children: ReactElement<any>[] | ReactElement<any>;
};

const Grid = ({ columns, className, children }: Props) => (
  <Root columns={columns} className={className}>
    {children}
  </Root>
);

const Root = styled('div')<{ columns: number }>(({ columns }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columns}, 1fr)`,
  gap: `${SPACING_UNIT * 2}px`,
}));

export default Grid;
